interface ApiError {
  data: {
    error: string;
  };
}

export const isApiError = (error: unknown): error is ApiError => {
  return (error as ApiError).data.error !== undefined;
};
